import { db } from '../firebase';
import { dispatch } from '../../store'
//import {LISTEN_EVENTS} from '../../constants/actionTypes'
import _ from 'lodash'

const usersRef = db.ref('/users')


export const doFetchUser = async (userId) => {

    const userSnap = await  usersRef.child(userId).once('value')
    const payload =  await userSnap.val()

    dispatch({type: 'FETCH_REQUESTER_INFO', payload})
    return payload
}

export const fetchUserProfile = async (userId) => {
    const userSnap = await  usersRef.child(userId).once('value')
    const payload =  await userSnap.val()
    return payload
}

export const fetchUserProfiles = async (userIds) => {
        const userArr = []
       // const countIds = Object.keys(userIds).length

    await _.map(userIds, async (userId, key) => {
        const userSnap = await usersRef.child(key).once('value')
        const userProfiles = await userSnap.val()
        userArr.push(userProfiles)
    })

    
}




// WEBPACK FOOTER //
// ./src/firebase/database/handleUsers.js